
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
  } from '@chakra-ui/react'
import NotificationService from '../../services/Notification'
export const DeleteNotification = ({isOpen,onClose, id, func}:any) => {
    const deleteNotification = () => {
        NotificationService.deleteNotification(id)
          .then((response: any) => {
            func(true);
           onClose();
          })
          .catch((e: Error) => {
            console.log(e);
          });
      }
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
    <ModalOverlay />
    <ModalContent>
      <ModalHeader>Delete Notification</ModalHeader>
      <ModalCloseButton />
      <ModalBody>
      Are you sure you want to delete Notification?
      </ModalBody>

      <ModalFooter>
      <Button  bgColor='#327171' color={"white"} mr={3} onClick={deleteNotification} >Delete</Button>
        <Button  bgColor='red' color={"white"} mr={3} onClick={onClose}>
          No
        </Button>
       
      </ModalFooter>
    </ModalContent>
  </Modal>
  )
}
